import { css } from "styled-components";
import { CTA } from "../../../../../../components/CTA";
import { AspectRatio } from "../../../../../../components/AspectRatio";
export const riotProductSkin = (chroma) => css `
  .content {
    display: flex;
    align-items: center;
    gap: 32px;

    ${chroma.mediaQueries.mobileDown} {
      flex-direction: column;
      gap: 24px;
      ${CTA} {
        align-self: flex-start;
      }
    }

    .primary-cta {
      cursor: pointer;
      ${chroma.mediaQueries.mobileDown} {
        text-align: center;
        width: 100%;
      }
    }

    .ratings {
      flex: 2;
      align-self: flex-start;

      .ratings-content {
        display: flex;
        padding: 4px;
        border-radius: 4px;
        flex: 2;
        align-items: center;
        gap: 8px;
        background-color: white;
        min-width: 200px;
        max-width: fit-content;
        .rating-logo ${AspectRatio} {
          height: 72px;
        }

        .rating-text-container {
          ${chroma.typography.body5}
          display: flex;
          flex-direction: column;
          justify-content: center;
          gap: 4px;

          .rating-text-item {
            font-size: 12px;
            line-height: 1;
            color: black;
            margin: 0;
            ${chroma.mediaQueries.mobileDown} {
              font-size: 10px;
            }
          }
        }
      }
    }
  }
`;
//# sourceMappingURL=index.js.map